import React from 'react';

import { TestID } from '../../testID';

export const DiskUsageInfo: React.FC<{
  connected: boolean;
  connecting: boolean;
  diskUsageValue?: string;
}> = ({ connected, connecting, diskUsageValue }) => {
  if (connecting) {
    return <em data-testid={TestID.BasicInfoNotConnecting}>Connecting...</em>;
  }

  if (!connected) {
    return <em data-testid={TestID.BasicInfoNotConnected}>Not connected</em>;
  }

  if (!diskUsageValue) {
    return <em data-testid={TestID.BasicInfoNoInfoToShow}>No info to show</em>;
  }

  return <div data-testid={TestID.BasicInfoDiskUsage}>{diskUsageValue}</div>;
};
